<template>
  <div class="order-list">
    <button @click="getOrdersByDateRange(new Date().setHours(-24,0,0,0),new Date().setHours(47,59,59,59))">昨日订单</button>
    <button @click="getOrdersByDateRange(new Date().setHours(0,0,0,0),new Date().setHours(23,59,59,59))">今日订单</button>
    <button @click="getOrdersByDateRange(0,new Date().setHours(23,59,59,59))">全部订单</button>
    <div v-if="!orders.length" class="order-404">
      暂时没有订单！
    </div>
    <div class="order-item" v-for="order in orders" @click="goToDetail(order)" :key="order._id">
      <div class="order-no">
        <span class="order-name">订单编号：{{order._id}}</span>
        <span class="order-status">{{order.status | calStatus}}</span>
      </div>
      <div class="goods-item">
        <ul>
          <li v-for='(g,index) in order.products' :key="g._id+index">
            <p class="cart-item">
              <span>{{g.name}}{{g.spec ? ` [${g.spec}]`:""}}</span>
              <span class="price">¥{{Math.round(100*g.quantity * g.price)/100}}</span>
              <span style="float:right" v-if="g.unit2">({{g.quantity/(Number((g.unit2 && g.priceTransfer || 1)))}}{{g.unit2 || '份'}})</span>
              <span class="quantity">&nbsp;&nbsp;&nbsp;&nbsp;{{g.quantity}}{{g.unit || '斤'}}</span>
              <span style="float: right; color: red" v-if="g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier._id">{{supplierMap[g.suppliers[0]]}}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="total-price">
          <span class="created_time">{{order.createTime | filterTime}}</span>
          <span>总计：¥{{order.roughPrice}} | {{STATUS_MAP[order.status]}}</span>
      </div>
      <div class="order-info">
        <span>备注：{{order.notes}}</span>
      </div>
      <div class="order-info">
          <span class="customer">客户：{{order.customer.name}}</span>
          <!-- <span class="supplier">供应商：{{order.supplier && order.supplier.name}}</span> -->
          <span class="supplier">配送员：{{order.delivery && order.delivery.name}}</span>
      </div>
      <!-- <div class="total-price">
          <span>下单人：{{order.placedBy.name}}{{" " + order.placedBy.phone}}</span>
      </div> -->
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../utils.scss";
    $base-color:#79BD50;
    .order-list {
      overflow: hidden;
    }
  .order-item {
    padding-left: px2rem(20px);
    background: white;
    margin-top: px2rem(10px);
    .order-no {
        border-bottom: 1px solid #e5e5e5;
        height: px2rem(44px);
        line-height: px2rem(44px);
        @include font-dpr(14px);
      .order-name {
        color: #333;
      }
      .order-status {
        color: #999;
        float: right;
        margin-right: px2rem(20px);
        &:after {
          content: ' ';
          display: inline-block;
          height: px2rem(15px);
          width: px2rem(15px);
          background: url("../assets/icon_arrow@2x.png") no-repeat;
          background-size: contain;
          margin-bottom: px2rem(-3px);
          margin-left: px2rem(7px);
         }
      }
    }
    .goods-item {
      border-bottom: 1px solid #e5e5e5;
      .cart-item {
        @include font-dpr(14px);
        color: #666;
        margin-top: px2rem(16px);
        padding: 0 px2rem(20px) 0  0 ;
        &:last-child {
            margin-bottom: px2rem(16px);
         }
         .quantity {
            float: right;
         }

         .price {
            float: right;
            width: px2rem(50px);
           text-align: right;
         }
      }
    }

    .total-price {
      height: px2rem(44px);
      line-height: px2rem(44px);
      color: #666;
      margin-right: px2rem(20px);
      .created_time {
        float: none;
      }
      span {
        float: right;
      }
    }
    .order-info {
      min-height: px2rem(30px);
      line-height: px2rem(30px);
      color: #666;
      margin-right: px2rem(20px);
      .supplier {
        float: right;
      }
    }
  }

    .order-404 {
      text-align: center;
      color: #666;
      @include font-dpr(14px);
      line-height: px2rem(30px);
  }


</style>

<script>
  import { host } from '../config'
  import utilMixin from './mixins/utils'

export default {
  name: 'hello',
  mixins: [utilMixin()],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
      orders: [],
      suppliers: [],
      dateRange: '',
    };
  },
  methods: {
    goToDetail(order) {
        // this.$router.push('/sales/order/' + order._id);
    },
    getOrdersByDateRange(startDate,endDate) {
      console.log(this.$route.params.id)
      console.log(startDate)
      console.log(endDate)
      this.$http.get(host + `/api/sales/${this.$route.params.id}/order/list` + "?" + "startDate=" + startDate + "&endDate=" + endDate, {withCredentials: true}).then(res => {
        console.log(res.data.data)
        this.orders = res.data.data
      })
    },
    getAllOrders(){
    // this.orders = [
    //   {
    //     "products": [
    //       {
    //         "name": "精肉丝",
    //         "price": 13.5,
    //         "quantity": 21.3,
    //         "spec": "粗整性",
    //         "unit": "斤",
    //         "_id": "5c7ea4957295f473a663c1e6",
    //         "suppliers": [],
    //         "cost": 11.5
    //       },
    //       {
    //         "name": "去骨羊肉",
    //         "price": 37,
    //         "priceTransfer": 0,
    //         "quantity": 8.9,
    //         "unit": "斤",
    //         "_id": "63632bb93473b716211c9da6",
    //         "suppliers": [],
    //         "cost": 35
    //       },
    //       {
    //         "name": "五花肉片",
    //         "price": 15,
    //         "quantity": 10.3,
    //         "unit": "斤",
    //         "_id": "5cac3c3a54949e12946b35c9",
    //         "suppliers": [],
    //         "cost": 12.5
    //       },
    //       {
    //         "name": "鲜羔羊排",
    //         "price": 30,
    //         "priceTransfer": 4,
    //         "quantity": 6,
    //         "unit": "斤",
    //         "unit2": "扇",
    //         "_id": "5d03c15ac60cbf199932b81e",
    //         "suppliers": [],
    //         "cost": 28
    //       }
    //     ],
    //     "roughPrice": 951.35,
    //     "actualPrice": 0,
    //     "status": 2,
    //     "_id": "64f4df353182b179c3329ed3",
    //     "address": {
    //       "name": "付老板",
    //       "tel": "15901773736",
    //       "street": "丰庄路272号"
    //     },
    //     "notes": "",
    //     "dueTime": "明天7:00-8:00",
    //     "placedBy": {
    //       "name": "水凯",
    //       "_id": "5c7f53ab525af9019b9f6ba9",
    //       "phone": "15901773736"
    //     },
    //     "customer": {
    //       "name": "东北小厨",
    //       "_id": "60b26e353473b716211c6b9f",
    //       "phone": "81622306357"
    //     },
    //     "sales": {
    //       "_id": "5ce4a131cbb83619214543ce",
    //       "name": "水凯",
    //       "phone": "15901773736",
    //       "createTime": "2019-05-22T01:09:05.613Z",
    //       "updateTime": "2019-05-22T01:09:05.613Z",
    //       "__v": 0
    //     },
    //     "delivery": {
    //       "_id": "64cbe2463473b716211cc47a",
    //       "name": "龙振亚",
    //       "createTime": "2023-08-03T17:22:14.931Z",
    //       "updateTime": "2023-08-13T11:32:26.877Z",
    //       "__v": 0
    //     },
    //     "supplier": {
    //       "_id": "5cb1c943ed318c3b5b8aaa9b",
    //       "name": "王相逢（X12)",
    //       "createTime": "2019-04-13T11:34:27.603Z",
    //       "updateTime": "2022-08-31T13:31:40.486Z",
    //       "__v": 0
    //     },
    //     "createTime": "2023-09-03T19:32:05.453Z",
    //     "updateTime": "2023-09-03T20:16:03.561Z",
    //     "__v": 0,
    //     "sendTime": "2023-09-03T20:15:41.344Z"
    //   }]
  }
  },
  computed: {
    supplierMap() {
      const map = {}
      this.suppliers.forEach(s => {
        map[s._id] = s.name
      })
      return map
    }
  },
  created() {
      this.$http.get(host + `/api/sales/${this.$route.params.id}/order/list`, {withCredentials: true}).then(res => {
        console.log(res)
        this.orders = res.data.data
      })
      this.getLogin().then(res => {
        if (!res) {
          this.$router.push('/login')
        }
      })
  },
  filters:{
      calStatus(val) {
          let res = ''
          switch(val){
              case "0":
                res='订单已失效';
                break;
              case "1":
                res='待支付';
                break;
              case "2":
                res ='支付成功';
                break;
              case "3":
                res = '已取消';
                break;
              case "4":
                res = '订单到付';
                break;
          }
          return res;
    }
  }
};
</script>




// WEBPACK FOOTER //
// SalesOrders.vue?b51a2cc6